import { render, staticRenderFns } from "./ToggleTitle.vue?vue&type=template&id=7f1f0c4b"
import script from "./ToggleTitle.vue?vue&type=script&lang=ts"
export * from "./ToggleTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports